import React from "react";

function WhiteLabelWalletHero() {
  return (
    <>
      <div
        className="banner-style-two-area bg-theme shadow theme text-light bg-cover"
        style={{
          background:
            "url(assets/img/bg/white_label_crypto_exchange_image.jpg)",
        }}
      >
        <div className="container">
          <div className="row align-center">
            <div className="col-xl-9 col-lg-8">
              <div className="banner-two-content">
                <h2 className="split-text-right split-text-in-right">
                  White Label Crypto Wallet
                </h2>
                <div className="info">
                  <p className="fade-up-anim">
                    Our White Label Crypto Wallet solution enables businesses to
                    launch their own branded digital wallets! These wallets are
                    fully customizable to meet unique requirements and provide a
                    seamless way to integrate blockchain technology into your
                    ecosystem while offering secure, reliable & efficient
                    transactions!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default WhiteLabelWalletHero;
